import data from "../../../../../src/Textarea/Textarea.docs.json";
import { Textarea } from '@primer/react';
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  Textarea,
  DeprecationBanner,
  React
};